"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUnsupportedFile = void 0;
var unsupportedFiles = [
    'apk',
    'asp',
    'aspx',
    'bat',
    'bin',
    'c',
    'cpp',
    'cs',
    'cab',
    'callback',
    'cer',
    'cfg',
    'cfm',
    'cgi',
    'pl',
    'class',
    'com',
    'cpl',
    'css',
    'cur',
    'dat',
    'db',
    'dbf',
    'deb',
    'dll',
    'dmg',
    'dmp',
    'drv',
    'exe',
    'flv',
    'fnt',
    'fon',
    'gadget',
    'h',
    'icns',
    'ico',
    'ini',
    'iso',
    'jar',
    'java',
    'js',
    'jsp',
    'key',
    'lnk',
    'mdb',
    'msi',
    'ogg',
    'ost',
    'otf',
    'part',
    'partial',
    'php',
    'pkg',
    'ps',
    'py',
    'rar',
    'rm',
    'rpm',
    'rss',
    'sav',
    'sh',
    'sql',
    'swf',
    'swift',
    'sys',
    'tar',
    'tar.gz',
    'tex',
    'toast',
    'ttf',
    'url',
    'vb',
    'vcd',
    'wpl',
    'wsf',
    'xhtml',
    'xlsm',
    'xml',
    'z',
];
var isUnsupportedFile = function (file) {
    var name = file.name;
    var extension = name.split('.').pop() || name;
    return unsupportedFiles.includes(extension);
};
exports.isUnsupportedFile = isUnsupportedFile;
